import { LoaderCircle } from "lucide-react";
import { type ComponentProps, memo } from "react";
import { cn } from "@/lib/utils";

type SpinnerProps = ComponentProps<typeof LoaderCircle>;

export const Spinner = memo(({ className, ...props }: SpinnerProps) => {
  return <LoaderCircle className={cn("animate-spin", className)} {...props} />;
});

Spinner.displayName = "Spinner";
